import { Navigate, Route, Routes } from 'react-router-dom'
import { allAdminRoutes, allBlankRoutes } from './index'
import DefaultLayout from '../layouts/DefaultLayout'
import Authlayout from '../layouts/authLayout'
import { useAuthContext } from '../context'
const AllRoutes = (props) => {
    const { getSession } = useAuthContext()

    return (
        <Routes>
            <Route>
                {allBlankRoutes.map((route, idx) => (
                    <Route
                        key={idx}
                        path={route.path}
                        element={
                            <DefaultLayout {...props}>{route.element}</DefaultLayout>
                        }
                    />
                ))}
            </Route>
            <Route>
                {allAdminRoutes.map((route, idx) => (
                    <Route
                        key={idx}
                        path={route.path}
                        element={
                            getSession() == null ? (
                                <Navigate
                                    to={{
                                        pathname: '/',
                                        search: 'next=' + route.path,
                                    }}
                                />
                            ) : (
                                <Authlayout {...props}>{route.element}</Authlayout>
                            )
                        }
                    />
                ))}
            </Route>
        </Routes>
    )
}
export default AllRoutes
